<div
    class="lg-panel-resize-menu-popup__icon-wrapper"
    role="menu"
    lgArrowNavigation
    [horizontalNavigation]="false"
>
    @for (item of _items; track item) {
        <div
            class="lg-panel-resize-menu-popup__icon-wrapper__icon"
            role="menuitem"
            tabindex="0"
            [attr.aria-label]="item.tooltipLc | lgTranslate"
            [lgTooltip]="item.tooltipLc | lgTranslate"
            (click)="_onItemClick(item)"
            (keydown.enter)="_onItemKey($event, item)"
            (keydown.space)="_onItemKey($event, item)"
        >
            <lg-icon [icon]="item.iconName"></lg-icon>
        </div>
    }
</div>
